import React from "react";
import { CategoryTable } from "components/table/category/CategoryTable";

const Category = () => {
    return (
        <>
            <CategoryTable/>
        </>
    );
}

export { Category };